import React, {useEffect, useState, Fragment} from 'react';
import { Button, Row, Col } from 'antd';
import InputField from '../../../../common/InputField';
import SelectOption from '../../../../common/SelectOption';
import InputNumberField from "../../../../common/InputNumberField";
import {SPACE_CATEGORY} from "../../../../common/constants";
import {useDispatch, useSelector} from "react-redux";
import {getPackageTypes} from "../../SpaceAction";
import { addPackageCount } from '../../../../../helper/spaceFormValidation';
import {
    rulesPackageDescription,
    rulesPackageName,
    rulesPackagePrice,
    rulesPackageQty
} from "../../../../../helper/FeildValidations";

const Packages = ({paymentOption, packageCategory, hotDeskIndex, pricingOptionIndex, isEdit, form,privateOffice}) =>{
    const formFields = isEdit ? form.getFieldValue() : null;
    const dispatch = useDispatch();
    const [buttonOption, setButtonOption] = useState(false);
    const [count, setCount] = useState([1])
    const packageTypes = useSelector((state) => state.space?.packageType?.data?.packageTypes || []);

    useEffect(()=>{
        if(isEdit){
            if(packageCategory === SPACE_CATEGORY.WORK && isPackageAdded(formFields?.events?.[0]?.chargings?.[pricingOptionIndex]?.packages)){
                addPackageCount(formFields?.events?.[0]?.chargings?.find(charge => paymentOption === charge?.chargingTypeDesc?.name)?.packages, setCount)
                setButtonOption(true);
            }
            if(packageCategory === SPACE_CATEGORY.MEETING && isPackageAdded(formFields?.chargings?.[pricingOptionIndex]?.packages)){
                addPackageCount(formFields?.chargings?.find(charge => paymentOption === charge?.chargingType?.name)?.packages, setCount)
                setButtonOption(true);
            }
        }
    },[formFields]);

    const isPackageAdded = (packages) => {
        if (!packages) {
            return false
        }
        return Boolean(packages.length)
    }
    
    const rules=[
        {
            required: true,
            message: 'Please Fill Input Field!'
        }
        ];

    const handleAddPackages = () => {
        setCount([...count, (count ? count[count.length - 1] + 1 : 1)]);
    };

    const handleRemovePackages = (selectedIndex) => {
        const copy = [...count];
        const stat = copy.filter((value, index) => { return index !== selectedIndex});

        setCount([...stat])
    };

    return(
        <div className="basic-details-wrapper">
            <h3>{paymentOption} package detail</h3>
            <Row>
                <Col offset={8}>
                    Do you provide your guests with optional {paymentOption} packages ?
                </Col>
            </Row>
            <Row>
                <Col offset={20}>
                    <Button onClick={()=>setButtonOption(true)}>yes</Button>
                </Col>
                <Col span={2}>
                    <Button onClick={()=> setButtonOption(false)}>no</Button>
                </Col>
            </Row>
            <br />
            {buttonOption && (
                <div>
                    {count?.map((number, index)=>{
                        return(
                        <Fragment >
                            <Row>
                                <Col offset={8}>
                                    Please provide the package details :
                                </Col>
                                <Col span={8}>
                                    {index !== 0 && (
                                        <Button onClick={() => handleRemovePackages(index)}>
                                            {' '}
                                            -{' '}
                                        </Button>
                                    )}
                                    {index === 0 && (
                                        <Button
                                            className="plus-btn hourly-duration"
                                            onClick={() => handleAddPackages()}
                                        >
                                            +
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col offset={7} span={19}>
                                    <SelectOption
                                        isMultiple={false}
                                        name={packageCategory === SPACE_CATEGORY.MEETING ?['chargings', pricingOptionIndex,'packages', index ,'type' ,'id']:['events',hotDeskIndex, 'chargings', pricingOptionIndex,'packages', index ,'type' ,'id']}
                                        placeholder={'Package Type'}
                                        label={'Package Type'}
                                        rules={rules}
                                        values={packageTypes}
                                        labelName={'name'}
                                        valueName={'id'}
                                    />

                                    <InputField
                                        name={packageCategory === SPACE_CATEGORY.MEETING ?['chargings', pricingOptionIndex,'packages', index ,'name']:['events',hotDeskIndex, 'chargings', pricingOptionIndex,'packages', index ,'name']}
                                        label={'Package Name'}
                                        rules={rulesPackageName}
                                    />

                                    <InputField
                                        name={packageCategory === SPACE_CATEGORY.MEETING ? ['chargings', pricingOptionIndex,'packages', index ,'description']:['events',hotDeskIndex, 'chargings', pricingOptionIndex,'packages', index ,'description']}
                                        label={'Package Description'}
                                        rules={rulesPackageDescription}
                                    />

                                    <InputNumberField
                                        name={packageCategory === SPACE_CATEGORY.MEETING ? ['chargings', pricingOptionIndex,'packages', index ,'quantity']:['events',hotDeskIndex, 'chargings', pricingOptionIndex,'packages', index ,'quantity']}
                                        label={packageCategory === SPACE_CATEGORY.MEETING || privateOffice ? 'Max Quantity' : 'Max Quantity Per Guest'}
                                        rules={rulesPackageQty}
                                        minAmount={1}
                                        maxAmount={999}
                                    />

                                    <InputNumberField
                                        name={packageCategory === SPACE_CATEGORY.MEETING ? ['chargings', pricingOptionIndex,'packages', index ,'price', 'amount']:['events',hotDeskIndex, 'chargings', pricingOptionIndex,'packages', index ,'price', 'amount']}
                                        label={'Package Price'}
                                        rules={rulesPackagePrice} />

                                </Col>
                            </Row>
                        </Fragment>
                        );
                    })}
                </div>

                )}
        </div>
        );
};

export default Packages;

